import { Button } from "../../ui";

const CopyListModalBody = ({ loading, listName, onCopy, onCancel, isImageToEntity = false }) => {
  const title = isImageToEntity ? "Copy to Select List" : "Copy to Image Select List";
  const targetListType = isImageToEntity ? "select list" : "image select list";
  const sourceListType = isImageToEntity ? "image select list" : "select list";
  const nameSuffix = isImageToEntity ? " - Select List" : " - Image List";
  const description = isImageToEntity
    ? "Create a new select list with all entities (instances/artworks) from the images in this list"
    : "Create a new image select list with all images from the entities (instances/artworks) in this list";

  return (
    <div className={`p-4`}>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className={`text-lg`}>{title}</div>
        <div className="flex flex-wrap gap-2 sm:gap-6">
          <Button
            className={`!w-28`}
            action="default"
            label="Cancel"
            onClick={onCancel}
          />
          <Button
            loading={loading}
            className={`flex !w-28 items-center`}
            label={loading ? "Copying" : "Copy"}
            onClick={onCopy}
          />
        </div>
      </div>
      <div className="mt-8 text-sm font-normal">
        <p className="mb-4">
          {listName
            ? `You are about to copy "${listName}" to a new ${targetListType}.`
            : `You are about to copy this ${sourceListType} to a new ${targetListType}.`}
        </p>
        <p className="mb-2 font-semibold">This will:</p>
        <ul className="mb-4 list-inside list-disc space-y-1">
          <li>Keep the original {sourceListType} intact</li>
          <li>{description}</li>
          <li>Name the new list with &ldquo;{nameSuffix}&rdquo; appended to the original name</li>
        </ul>
        <p className="text-gray-600">
          The original list will remain unchanged.
        </p>
      </div>
    </div>
  );
};

export default CopyListModalBody;

